/**
 * Shared date formatting utilities.
 * English dates use DD MMM YYYY format (e.g. "24 Feb 2026").
 */

function getDateLocale(locale) {
  if (!locale || locale.startsWith('en')) return 'en-GB'
  return locale
}

const DATE_OPTIONS = { day: '2-digit', month: 'short', year: 'numeric' }

const TIME_OPTIONS = { hour: '2-digit', minute: '2-digit', hour12: false }

export function formatDate(dateStr, locale) {
  if (!dateStr) return '\u2014'
  return new Date(dateStr).toLocaleDateString(getDateLocale(locale), DATE_OPTIONS)
}

export function formatDateTime(dateStr, locale) {
  if (!dateStr) return '\u2014'
  const dl = getDateLocale(locale)
  const d = new Date(dateStr)
  const date = d.toLocaleDateString(dl, DATE_OPTIONS)
  const time = d.toLocaleTimeString(dl, TIME_OPTIONS)
  return `${date}, ${time}`
}
